import { ContentfulLivePreview } from '@contentful/live-preview';

// Helper function to get live update attributes
export function liveUpdateAttrs(entryId?: string, fieldId?: string) {
  if (!entryId || !fieldId) return {};

  return ContentfulLivePreview.getProps({ entryId, fieldId });
}
